import { gql } from '@apollo/client';

export const GET_ROSTER_BY_ID = gql`
  query getRosterById($rosterId: String!) {
    rosterById(rosterId: $rosterId) {
      groupId
      groupName
      worldTennisTeamNumbers {
        type
        average
      }
    }
  }
`;
